// extracted by mini-css-extract-plugin
export var questionBox = "_60-0";